var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRsa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Capa_1",
    "data-name": "Capa 1",
    viewBox: "0 0 1044.37 366.25",
    width: 1044.37,
    height: 366.25,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 1044.37,357.87 975.46,357.99 850.56,84.12 730.88,357.99 H 661.54 L 818.84,8.73 H 883.5 Z M 277.86,110.44 C 276.94,49.12 226.37,6.33 154.77,6.33 H 0 V 357.41 H 56.37 V 57.59 h 95.18 c 31.88,0 66.15,15.78 66.71,53.6 0.5,33.64 -25.95,54.68 -70.76,56.48 l -0.88,0.06 -34.13,0.29 113.66,190 66.58,-0.12 -89,-149.49 c 50.53,-17.95 74.69,-57.59 74.13,-97.97 z m 222.74,40 c -59.23,-15.92 -82.32,-29.32 -82.32,-56.47 0,-41.14 53,-45.13 72,-45.13 29.83,0 67.78,9.5 90.23,20.52 l 23.81,-44.5 C 574,9.97 527.54,0 488.7,0 406.03,0 354.28,35.78 354.28,97 c 0,69.9 73,89.65 129.74,104.85 59.1,15.89 79.71,33.8 79.71,61 0,45.27 -48.3,52.33 -78.19,52.33 -41,0 -74.93,-10.9 -108,-30.34 l -28.35,45.48 c 41.78,24.5 85.1,35.93 136.3,35.93 85.5,0 142.29,-42.1 142.29,-107.27 0,-72.76 -69.1,-92.9 -127.18,-108.46 z",
    id: "path2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRsa);
export default __webpack_public_path__ + "static/media/rsa.4215f117a16266fea20d77dca43ed525.svg";
export { ForwardRef as ReactComponent };